import React from 'react'

export const Chevron = ({ className }) => (
    <svg role="presentation" viewBox="0 0 614 1024" className={className}>
        <path d="M508.201-2.299c-8.907 0.365-16.581 3.928-24.027 11.237l-8.77 8.588-459.756 459.711c-8.588 8.633-13.338 20.099-13.338 32.295s4.751 23.662 13.338 32.295l468.709 468.572c7.491 7.354 15.165 10.917 24.21 11.283 7.902 0.32 20.007-7.035 33.117-20.144 8.542-8.588 16.81-17.632 24.529-26.95 1.919-2.33 3.563-4.431 5.070-6.349l-22.657-22.611-436.049-436.095 458.386-458.386c-1.507-1.919-3.198-4.065-5.116-6.395-7.674-9.273-15.942-18.317-24.484-26.859-13.11-13.155-25.215-20.51-33.163-20.19z" />
    </svg>
)

export const MenuIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 1024 1024">
        <path d="M0 852.329h1024v-114.447h-1024v114.447zM0 569.224h1024v-114.447h-1024v114.447zM0 171.671v114.447h1024v-114.447h-1024z" />
    </svg>
)

export const CloseIcon = ({ className, color="#ffffff", btnColor }) => (
    <svg role="presentation" className={className} viewBox="0 0 357 357">
        <path fill={btnColor && btnColor ? btnColor : color} d="M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8" />
    </svg>
)

export const SearchIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 1024 1024">
        <path d="M995.2 902.4l-214.4-214.4c51.2-70.4 76.8-150.4 76.8-243.2 0-230.4-188.8-419.2-419.2-419.2s-422.4 185.6-422.4 416c0 233.6 188.8 422.4 419.2 422.4 96 0 185.6-35.2 259.2-89.6l163.2 163.2c3.2 3.2 3.2 3.2 6.4 3.2l41.6 41.6 89.6-80zM435.2 768c-176 0-320-144-320-320s144-320 320-320c176 0 320 144 320 320 0 73.6-25.6 144-64 195.2-16 19.2-32 35.2-44.8 51.2-57.6 44.8-131.2 73.6-211.2 73.6v0z" />
    </svg>
)

export const WhatsAppIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 32 32">
        <path d="M27.281 4.65c-2.994-3-6.975-4.65-11.219-4.65-8.738 0-15.85 7.112-15.85 15.856 0 2.794 0.731 5.525 2.119 7.925l-2.25 8.219 8.406-2.206c2.319 1.262 4.925 1.931 7.575 1.931h0.006c0 0 0 0 0 0 8.738 0 15.856-7.113 15.856-15.856 0-4.238-1.65-8.219-4.644-11.219zM16.069 29.050v0c-2.369 0-4.688-0.637-6.713-1.837l-0.481-0.288-4.987 1.306 1.331-4.863-0.313-0.5c-1.325-2.094-2.019-4.519-2.019-7.012 0-7.269 5.912-13.181 13.188-13.181 3.519 0 6.831 1.375 9.319 3.862 2.488 2.494 3.856 5.8 3.856 9.325-0.006 7.275-5.919 13.188-13.181 13.188zM23.294 19.175c-0.394-0.2-2.344-1.156-2.706-1.288s-0.625-0.2-0.894 0.2c-0.262 0.394-1.025 1.288-1.256 1.556-0.231 0.262-0.462 0.3-0.856 0.1s-1.675-0.619-3.188-1.969c-1.175-1.050-1.975-2.35-2.206-2.744s-0.025-0.613 0.175-0.806c0.181-0.175 0.394-0.463 0.594-0.694s0.262-0.394 0.394-0.662c0.131-0.262 0.069-0.494-0.031-0.694s-0.894-2.15-1.219-2.944c-0.319-0.775-0.65-0.669-0.894-0.681-0.231-0.012-0.494-0.012-0.756-0.012s-0.694 0.1-1.056 0.494c-0.363 0.394-1.387 1.356-1.387 3.306s1.419 3.831 1.619 4.1c0.2 0.262 2.794 4.269 6.769 5.981 0.944 0.406 1.681 0.65 2.256 0.837 0.95 0.3 1.813 0.256 2.494 0.156 0.762-0.113 2.344-0.956 2.675-1.881s0.331-1.719 0.231-1.881c-0.094-0.175-0.356-0.275-0.756-0.475z" />
    </svg>
)

export const TwitterIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 32 32">
        <path d="M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z" />
    </svg>
)

export const FacebookIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 32 32">
        <path d="M19 6h5v-6h-5c-3.86 0-7 3.14-7 7v3h-4v6h4v16h6v-16h5l1-6h-6v-3c0-0.542 0.458-1 1-1z" />
    </svg>
)

export const InstagramIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 512 512">
        <path d="M336 96c21.2 0 41.3 8.4 56.5 23.5S416 154.8 416 176v160c0 21.2-8.4 41.3-23.5 56.5S357.2 416 336 416H176c-21.2 0-41.3-8.4-56.5-23.5S96 357.2 96 336V176c0-21.2 8.4-41.3 23.5-56.5S154.8 96 176 96h160m0-32H176c-61.6 0-112 50.4-112 112v160c0 61.6 50.4 112 112 112h160c61.6 0 112-50.4 112-112V176c0-61.6-50.4-112-112-112z" />
        <path d="M360 176c-13.3 0-24-10.7-24-24s10.7-24 24-24c13.2 0 24 10.7 24 24s-10.8 24-24 24zM256 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64m0-32c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z" />
    </svg>
)

export const EmailIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 32 32">
        <path d="M29 4h-26c-1.657 0-3 1.343-3 3v18c0 1.656 1.343 3 3 3h26c1.657 0 3-1.344 3-3v-18c0-1.657-1.343-3-3-3zM2.741 25.99l-0.731-0.732 8.249-8.248 0.731 0.732-8.249 8.248zM29.259 25.99l-8.249-8.248 0.731-0.732 8.249 8.248-0.731 0.732zM17 19.325v0.675h-2v-0.675l-12.997-12.050 1.272-1.272 12.725 11.798 12.725-11.798 1.272 1.272-12.997 12.050z" />
    </svg>
)

export const UserIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 26 26">
        <path d="M13 2.71c-1.775 0-3.22 1.445-3.22 3.22 0 1.775 1.445 3.22 3.22 3.22 1.775-.002 3.218-1.446 3.218-3.22 0-1.775-1.443-3.22-3.218-3.22m0 8.438c-2.878 0-5.22-2.34-5.22-5.218C7.78 3.053 10.123.71 13 .71c2.877 0 5.22 2.343 5.22 5.22s-2.343 5.22-5.22 5.22M3.61 23.29h18.78c-1.61-3.683-5.298-6.157-9.39-6.157-4.09 0-7.78 2.474-9.39 6.156zm21.525 2H.865l.365-1.276c1.495-5.23 6.334-8.88 11.77-8.88s10.276 3.65 11.77 8.88l.365 1.275z" />
    </svg>
)

export const TrashIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox='0 0 30 30'>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="#fff" fillRule="evenodd">
            <g id="icon-trash" stroke="#000">
                <g id="Group-4" transform="translate(5.000000, 5.000000)">
                    <rect id="Rectangle-4" x="7.5" y="0.5" width="6" height="3"></rect>
                    <rect id="Rectangle-4" x="3.5" y="3.5" width="14" height="17"></rect>
                    <path d="M0.5,3.5 L20.5,3.5" id="Line" strokeLinecap="square"></path>
                    <path d="M7.5,7.5 L7.5,16.5" id="Line" strokeLinecap="square"></path>
                    <path d="M10.5,7.5 L10.5,16.5" id="Line" strokeLinecap="square"></path>
                    <path d="M13.5,7.5 L13.5,16.5" id="Line" strokeLinecap="square"></path>
                </g>
            </g>
        </g>
    </svg>
)


export const RemoveFromFavoritesIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 59.02 49.11">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_2-2" data-name="Layer 2">
                <g id="oAFm60">
                    <path style={{ fill: '#db0000', strokeLinecap: 'round', strokeLinejoin: 'bevel', strokeWidth: '3.95px' }} d="M29,10.86c.16-.38.27-.68.4-1A12.32,12.32,0,0,1,38,2.73a16,16,0,0,1,8.57-.15,13.1,13.1,0,0,1,9.24,8.82A21.22,21.22,0,0,1,57,16.68,15.19,15.19,0,0,1,55.17,25a35.39,35.39,0,0,1-7,9.07,73.63,73.63,0,0,1-14.13,10.5c-1.65,1-3.33,1.91-5,2.87C27,46.16,24.93,45,22.92,43.7a69.32,69.32,0,0,1-12-9.33A35.3,35.3,0,0,1,3.53,24.31,15.55,15.55,0,0,1,2,16.94,22.23,22.23,0,0,1,3.33,10.7,12.88,12.88,0,0,1,17.11,2.05a16.33,16.33,0,0,1,5,1.21A12.06,12.06,0,0,1,29,10.86Z" />
                </g>
            </g>
        </g>
    </svg>
)

export const AddToFavoritesIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 59.02 49.11">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_2-2" data-name="Layer 2">
                <g id="oAFm60">
                    <path style={{ fill: 'none', stroke: 'white', strokeLinecap: 'round', strokeLinejoin: 'bevel', strokeWidth: '3.95px' }} d="M29,10.86c.16-.38.27-.68.4-1A12.32,12.32,0,0,1,38,2.73a16,16,0,0,1,8.57-.15,13.1,13.1,0,0,1,9.24,8.82A21.22,21.22,0,0,1,57,16.68,15.19,15.19,0,0,1,55.17,25a35.39,35.39,0,0,1-7,9.07,73.63,73.63,0,0,1-14.13,10.5c-1.65,1-3.33,1.91-5,2.87C27,46.16,24.93,45,22.92,43.7a69.32,69.32,0,0,1-12-9.33A35.3,35.3,0,0,1,3.53,24.31,15.55,15.55,0,0,1,2,16.94,22.23,22.23,0,0,1,3.33,10.7,12.88,12.88,0,0,1,17.11,2.05a16.33,16.33,0,0,1,5,1.21A12.06,12.06,0,0,1,29,10.86Z" />
                </g>
            </g>
        </g>
    </svg>
)

export const FollowHeartIcon = ({ className }) => (
    <svg className={className} width="21px" height="19px" viewBox="0 0 21 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Web-CONCEPT-DETAIL-S" transform="translate(-256.000000, -67.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
                <g id="top" transform="translate(0.000000, 56.000000)" fill="#FFFFFF" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                    <g id="icon/follow-selected" transform="translate(257.000000, 12.000000)">
                        <path d="M9.50001414,18 L1.66337777,10.0308293 C0.579945956,8.92843902 -0.0263267717,7.37385366 0.000877773777,5.76614634 C0.018150501,2.71492683 2.48987777,0.257268293 5.52642323,0.257268293 C7.00453686,0.257268293 8.42737777,0.895609756 9.49958232,2.02478049 C10.5726505,0.895609756 11.996355,0.257268293 13.473605,0.257268293 C16.5192187,0.257268293 18.9969914,2.73029268 18.9991505,5.76965854 C19.0250596,7.3764878 18.4192187,8.92931707 17.3362187,10.0308293 L9.50001414,18 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const AddToWatchlistIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 40 40">
        <defs>
            <circle id="path-1" cx="20" cy="20" r="20"></circle>
        </defs>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Buttons/watchlist">
                <g id="Group-2">
                    <g id="Oval-5">
                        <use fillOpacity="0.75" fillRule="evenodd" xlinkHref="#path-1"></use>
                        <circle stroke="currentColor" strokeWidth="2" cx="20" cy="20" r="19"></circle>
                    </g>
                    <polygon id="Combined-Shape" fill="currentColor" points="22.0650107 17.9266945 22.0650107 9.48854866 17.9349893 9.48854866 17.9349893 17.9266945 9.60467529 17.9266945 9.60467529 22.0733055 17.9349893 22.0733055 17.9349893 30.5114513 22.0650107 30.5114513 22.0650107 22.0733055 30.3953247 22.0733055 30.3953247 17.9266945"></polygon>
                </g>
            </g>
        </g>
    </svg>
)

export const RemoveFromWatchlistIcon = ({ className }) => (
    <svg role="presentation" className={className} viewBox="0 0 40 40">
        <defs>
            <circle id="b" cx="20" cy="20" r="20" />
            <filter id="a" width="137.5%" height="137.5%" x="-11.2%" y="-13.7%" filterUnits="objectBoundingBox">
                <feOffset dx="3" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.225600091 0" in="shadowBlurOuter1" />
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
            <use filter="url(#a)" xlinkHref="#b" />
            <use fillOpacity=".75" xlinkHref="#b" />
            <circle cx="20" cy="20" r="19" stroke="currentColor" strokeWidth="2" />
            <path fill="currentColor" d="M9.605 17.927v4.146h20.79v-4.146" />
        </g>
    </svg>
)

export const BackArrowIcon = ({ className }) => (
    <svg width="14px" height="10px" viewBox="0 0 14 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Web-CONCEPT-DETAIL-S" transform="translate(-13.000000, -70.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
                <g id="top" transform="translate(0.000000, 56.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                    <g id="icon/back" transform="translate(14.000000, 14.000000)">
                        <g transform="translate(0.000000, 0.500000)" id="Shape">
                            <path d="M12.5,4.75 L0,4.75"></path>
                            <polyline points="4.6875 9.5 0 4.75 4.6875 0"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const TriangleIcon = ({ className, color }) => (
    <svg role="presentation" className={className} width="20px" height="10px" viewBox="0 0 20 10">
        <g id="WebApps-No-Playlist" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="W01-Home-Loggedin" transform="translate(-943.000000, -46.000000)" fill={color || "#FFFFFF"}>
                <g id="Group-4" transform="translate(50.000000, 15.000000)">
                    <g id="Group-2" transform="translate(354.000000, 22.000000)">
                        <polygon id="Triangle" points="549 19 539 9 559 9"></polygon>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const CalendarIcon = ({ className }) => (
    <svg role="presentation" className={className} width="21px" height="24px" viewBox="0 0 21 24" version="1.1">
        <g id="Symbols" stroke="none" strokeWidth="2" fill="none" fillRule="evenodd">
            <g id="icon-/-calendar" transform="translate(-1.000000, 0.000000)">
                <g id="calendar" transform="translate(2.000000, 1.000000)">
                    <path d="M2,2 L16,2 C17.1045695,2 18,2.8954305 18,4 C18,6.69637044 18,9.39274089 18,12.0891113 C18,14.0594076 18,16.0297038 18,18 L18,18 C18,19.1045695 17.1045695,20 16,20 C13.634196,20 11.2683919,20 8.90258789,20 C6.60172526,20 4.30086263,20 2,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,4 C-1.3527075e-16,2.8954305 0.8954305,2 2,2 Z" id="Rectangle-path" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                    <rect id="Rectangle" fill="#222222" x="10" y="13" width="10" height="10"></rect>
                    <path d="M13,0 L13,4" id="Shape1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M5,0 L5,4" id="Shape2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M0,8 L18,8" id="Shape3" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                    <path d="M13,18 L17,18" id="Shape-Copy1" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"></path>
                    <path d="M15,16 L15,20" id="Shape-Copy2" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round"></path>
                </g>
            </g>
        </g>
    </svg>
)

export const TimerSVG = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.48 60.05">
        <defs></defs>
        <title>timer</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path className="cls-1" fill="#ed1c24" d="M32,0H21.89a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2h.23l.08,1.9A23.14,23.14,0,0,1,32,6V3.93h0a2,2,0,0,0,2-2h0A2,2,0,0,0,32,0Z" />
                <path className="cls-1" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M9,10.37l-.92-1,.2-.21A1.53,1.53,0,0,0,8.29,7l-.11-.11A1.53,1.53,0,0,0,6,6.91L1.45,11.49a1.51,1.51,0,0,0,0,2.15l.11.12a1.52,1.52,0,0,0,1.93.17l.86.92a1.81,1.81,0,0,0,.3,1.77,46.13,46.13,0,0,1,6.08-6A1.88,1.88,0,0,0,9,10.37Z" />
                <path className="cls-1" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M52.49,11.49,47.9,6.91a1.53,1.53,0,0,0-2.15,0L45.64,7a1.53,1.53,0,0,0,0,2.15l.21.21-.93,1a1.86,1.86,0,0,0-1.71.24,46.39,46.39,0,0,1,6.07,6,1.83,1.83,0,0,0,.31-1.77l.85-.92a1.53,1.53,0,0,0,1.94-.17l.11-.12A1.53,1.53,0,0,0,52.49,11.49Z" />
                <path className="cls-2" fill="none" stroke="#ed1c24" strokeMiterlimit="10" strokeWidth="2.32px" d="M26.74,7.73A25.58,25.58,0,1,0,52.32,33.31,25.58,25.58,0,0,0,26.74,7.73Z" />
            </g>
        </g>
    </svg>
)

export const FiltersSVG = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.07 48.79">
        <title>menu-filter</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <circle cx="12.88" cy="7.36" r="7.36" />
                <circle cx="53.22" cy="24.53" r="7.36" />
                <circle cx="27.6" cy="41.43" r="7.36" />
                <rect y="4.91" width="68.07" height="5.52" />
                <rect y="21.46" width="68.07" height="5.52" />
                <rect y="38.02" width="68.07" height="5.52" />
            </g>
        </g>
    </svg>
)


export const FiltersTransparent = ({ className }) => (
    <svg className={className} width="20" height="17" viewBox="0 0 20 17">
        <path fill="#D5202D" fillRule="nonzero" d="M8.184 0C7.01 0 6.01.796 5.631 1.889H.92a.901.901 0 0 0-.797.468.977.977 0 0 0 0 .952c.165.295.47.474.797.469h4.71C6.01 4.87 7.01 5.667 8.184 5.667c1.174 0 2.175-.796 2.554-1.89h8.341a.901.901 0 0 0 .797-.468.977.977 0 0 0 0-.952.901.901 0 0 0-.797-.468h-8.341C10.358.796 9.358 0 8.184 0zm0 1.889c.512 0 .908.412.908.944 0 .533-.396.945-.908.945s-.908-.412-.908-.945c0-.532.396-.944.908-.944zm5.448 3.778c-1.174 0-2.175.796-2.554 1.889H.921a.901.901 0 0 0-.797.468.977.977 0 0 0 0 .952c.165.294.47.473.797.468h10.157c.38 1.093 1.38 1.89 2.554 1.89s2.174-.797 2.553-1.89h2.894a.901.901 0 0 0 .797-.468.977.977 0 0 0 0-.952.901.901 0 0 0-.797-.468h-2.894c-.379-1.093-1.38-1.89-2.553-1.89zm0 1.889c.512 0 .908.411.908.944 0 .533-.396.944-.908.944-.494 0-.87-.386-.898-.89a.982.982 0 0 0 0-.11c.028-.503.405-.888.898-.888zm-7.264 3.777c-1.178 0-2.183.802-2.558 1.902a.874.874 0 0 0-.165-.013H.92a.901.901 0 0 0-.797.469.977.977 0 0 0 0 .952c.165.294.47.473.797.468h2.724c.055 0 .11-.004.165-.015C4.184 16.197 5.189 17 6.368 17c1.174 0 2.175-.796 2.554-1.889h10.157a.901.901 0 0 0 .797-.468.977.977 0 0 0 0-.952.901.901 0 0 0-.797-.469H8.922c-.38-1.093-1.38-1.889-2.554-1.889zm0 1.89c.513 0 .908.41.908.944 0 .532-.395.944-.908.944-.512 0-.908-.412-.908-.944 0-.533.396-.945.908-.945z" />
    </svg>

)

export const Bookmark = ({ className }) => (
    <svg className={className} width="18px" height="22px" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1">
            <g id="classRow/browse-S" transform="translate(-280.000000, -5.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="320" height="81"></rect>
                <g id="2" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                    <g id="icon/bookmark" transform="translate(281.000000, 5.000000)">
                        <path d="M15.9571427,20.6562497 L8.1,15.1006942 L0.24285725,20.6562497 L0.24285725,2.87847219 C0.24285725,1.65117276 1.24793229,0.65625 2.48775518,0.65625 L13.7122448,0.65625 C14.9520677,0.65625 15.9571427,1.65117276 15.9571427,2.87847219 L15.9571427,20.6562497 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
export const ThumbIcon = ({ className }) => (
    <svg className={className} width="20px" height="20px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <g id="Web-VIDEO-DETAIL-M" transform="translate(-197.000000, -430.000000)" stroke="#FFFFFF">
                <g id="title" transform="translate(20.000000, 365.000000)">
                    <g id="rating" transform="translate(177.000000, 66.000000)">
                        <g id="thumbs-up-XS-quiet" transform="translate(0.500000, 0.000000)">
                            <g id="thumbs-up">
                                <path d="M8.4,4.9 L8.4,2.1 C8.4,0.940202025 7.45979797,1.77635684e-16 6.3,-4.4408921e-16 L3.5,6.3 L3.5,14.0000908 L11.396,14 C12.0941007,14.0078921 12.6913228,13.5002533 12.796,12.81 L13.762,6.51 C13.8236392,6.10389872 13.703828,5.69121616 13.434301,5.38126004 C13.1647739,5.07130391 12.7727262,4.89534875 12.362,4.9 L8.4,4.9 Z M3.5,14 L1.4,14 C0.62680135,14 0,13.3731986 0,12.6 L0,7.7 C-1.55431223e-16,6.92680135 0.62680135,6.3 1.4,6.3 L3.5,6.3 L3.5,14 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>)

export const FacebookRounded = ({ className }) => (
    <svg className={className} width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="team/team-page-schedule-desktop-copy" transform="translate(-1114.000000, -119.000000)" fill="#FFFFFF">
                <g id="Group-30">
                    <g id="Group-16" transform="translate(0.000000, 91.000000)">
                        <g id="Group-4">
                            <g id="Group-7" transform="translate(256.000000, 14.000000)">
                                <path d="M873,14 C864.7,14 858,20.7 858,29 C858,37.3 864.7,44 873,44 C881.3,44 888,37.3 888,29 C888,20.7 881.3,14 873,14 Z M877.5,29 L874.6,29 L874.6,38.9 L870.3,38.9 L870.3,29 L868,29 L868,25.7 L870.3,25.7 L870.3,23.5 C870.3,20.7 871.5,19.1 875,19.1 L877.9,19.1 L877.9,22.4 L876.2,22.4 C874.8,22.4 874.6,22.8 874.6,23.7 L874.6,25.7 L877.9,25.7 L877.5,29 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>)

export const InstagramRounded = ({ className }) => (
    <svg className={className} width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="team/team-page-schedule-desktop-copy" transform="translate(-1214.000000, -119.000000)" fill="#FFFFFF">
                <g id="Group-30">
                    <g id="Group-16" transform="translate(0.000000, 91.000000)">
                        <g id="Group-4">
                            <g id="Group-7" transform="translate(256.000000, 14.000000)">
                                <g id="icon-instagram" transform="translate(958.000000, 14.000000)">
                                    <g id="Group">
                                        <path d="M15,18.1 C16.7,18.1 18,16.8 18,15.1 C18,14.4 17.8,13.8 17.4,13.3 C16.9,12.5 16,12 15,12 C14,12 13.1,12.5 12.6,13.3 C12.2,13.8 12,14.4 12,15.1 C12,16.7 13.4,18.1 15,18.1 L15,18.1 Z" id="Shape"></path>
                                        <polygon id="Shape" points="21.9 11.9 21.9 9 19 9 19 11.9"></polygon>
                                        <path d="M15,0 C6.7,0 0,6.7 0,15 C0,23.3 6.7,30 15,30 C23.3,30 30,23.3 30,15 C30,6.7 23.3,0 15,0 Z M23.6,13.2 L23.6,20.2 C23.6,22 22.1,23.5 20.3,23.5 L9.8,23.5 C8,23.5 6.5,22 6.5,20.2 L6.5,9.7 C6.5,7.9 8,6.4 9.8,6.4 L20.3,6.4 C22.1,6.4 23.6,7.9 23.6,9.7 L23.6,13.2 Z" id="Shape"></path>
                                        <path d="M19.5,14.8 C19.5,17.4 17.4,19.5 14.8,19.5 C12.2,19.5 10.1,17.4 10.1,14.8 C10.1,14.2 10.2,13.6 10.4,13 L8,13 L8,20 C8,20.9 8.7,21.6 9.6,21.6 L20.1,21.6 C21,21.6 21.7,20.9 21.7,20 L21.7,13 L19.2,13 C19.4,13.6 19.5,14.2 19.5,14.8 L19.5,14.8 Z" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>)

export const TwitterRounded = ({ className }) => (<svg className={className} width="30px" height="30px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="team/team-page-schedule-desktop-copy" transform="translate(-1164.000000, -119.000000)" fill="#FFFFFF">
            <g id="Group-30">
                <g id="Group-16" transform="translate(0.000000, 91.000000)">
                    <g id="Group-4">
                        <g id="Group-7" transform="translate(256.000000, 14.000000)">
                            <g id="icon-twitter" transform="translate(908.000000, 14.000000)">
                                <path d="M15,0 C6.7,0 0,6.7 0,15 C0,23.3 6.7,30 15,30 C23.3,30 30,23.3 30,15 C30,6.7 23.3,0 15,0 Z M23.8,11 L23.8,11.5 C23.8,16.9 19.7,23.2 12.1,23.2 C9.8,23.2 7.6,22.5 5.8,21.3 C6.1,21.4 6.5,21.4 6.8,21.4 C8.7,21.4 10.5,20.7 11.9,19.6 C10.1,19.5 8.6,18.3 8.1,16.7 C8.4,16.8 8.6,16.8 8.9,16.8 C9.3,16.8 9.7,16.8 10,16.7 C8.1,16.3 6.7,14.7 6.7,12.7 L6.7,12.6 C7.3,12.9 7.9,13.1 8.6,13.1 C7.5,12.4 6.8,11.1 6.8,9.7 C6.8,8.9 7,8.2 7.3,7.5 C9.4,10 12.4,11.6 15.8,11.8 C15.7,11.5 15.7,11.2 15.7,10.9 C15.7,8.6 17.5,6.8 19.8,6.8 C21,6.8 22,7.3 22.8,8.1 C23.7,7.9 24.6,7.6 25.4,7.1 C25.1,8.1 24.4,8.9 23.6,9.4 C24.5,9.3 25.3,9.1 26,8.8 L26,8.8 C25.4,9.6 24.8,10.3 23.8,11 L23.8,11 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
)

export const ShopRounded = ({ className }) => (<svg className={className} width="31px" height="31px" viewBox="0 0 31 31" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Final-final" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile_-schedule-+-icon-highlight" transform="translate(-272.000000, -448.000000)" fill="#FFFFFF">
            <g id="Group-10" transform="translate(272.000000, 448.000000)">
                <path d="M15.5,31 C6.93958638,31 0,24.0604136 0,15.5 C0,6.93958638 6.93958638,0 15.5,0 C24.0604136,0 31,6.93958638 31,15.5 C31,24.0604136 24.0604136,31 15.5,31 Z M10.4785714,10.6765432 C10.2799484,9.76287794 9.29287726,9.09819715 8.14285714,9.1037037 L6.66428571,9.1037037 C6.30924552,9.1037037 6.02142857,9.33585235 6.02142857,9.62222222 C6.015378,9.76118058 6.08116242,9.89592239 6.20305789,9.99424137 C6.32495336,10.0925604 6.4920057,10.145621 6.66428571,10.1407407 L8.14285714,10.1407407 C8.66373664,10.1408231 9.11215249,10.437405 9.21428571,10.8493827 L11.0785714,19.162963 C10.2725746,19.4689883 9.75589749,20.1209906 9.75,20.8395062 C9.66504171,21.5524752 10.0886745,22.2426311 10.8431421,22.6203845 C11.5976097,22.9981378 12.5523903,22.9981378 13.3068579,22.6203845 C14.0613255,22.2426311 14.4849583,21.5524752 14.4,20.8395062 C14.3906184,20.5511139 14.3028369,20.2679013 14.1428571,20.0098765 L17.9571429,20.0098765 C17.8039115,20.2690801 17.7234293,20.5523488 17.7214286,20.8395062 C17.7214286,21.8704377 18.7575696,22.7061728 20.0357143,22.7061728 C21.313859,22.7061728 22.35,21.8704377 22.35,20.8395062 C22.35,19.8085746 21.313859,18.9728395 20.0357143,18.9728395 L12.3428571,18.9728395 L12.0857143,17.8148148 L19.95,17.8148148 C21.2396818,17.817249 22.3600743,17.1000339 22.65,16.0864198 L23.9785714,11.5407407 L10.6714286,11.5407407 L10.4785714,10.6765432 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </g>
</svg>
)

export const TicketRounded = ({ className }) => (
    <svg className={className} width="31px" height="31px" viewBox="0 0 31 31" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Final-final" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Mobile_-schedule-_-tap-icon" transform="translate(-272.000000, -491.000000)">
                <g id="social/ticket" transform="translate(272.000000, 491.000000)" fill="#FFFFFF">
                    <path d="M15.5,31 C6.93958638,31 0,24.0604136 0,15.5 C0,6.93958638 6.93958638,0 15.5,0 C24.0604136,0 31,6.93958638 31,15.5 C31,24.0604136 24.0604136,31 15.5,31 Z M22.416,16.928 L22.416,14.984 C22.416,14.624 22.128,14.318 21.75,14.318 L19.5,14.318 C19.464,14.498 19.302,14.642 19.104,14.642 C18.906,14.642 18.744,14.498 18.708,14.318 L6.828,14.318 C6.468,14.318 6.162,14.606 6.162,14.984 L6.162,16.928 C6.936,16.928 7.566,17.558 7.566,18.35 C7.566,19.124 6.936,19.772 6.162,19.772 L6.162,21.716 C6.162,22.076 6.45,22.382 6.828,22.382 L18.708,22.382 C18.744,22.202 18.906,22.058 19.104,22.058 C19.302,22.058 19.464,22.202 19.5,22.382 L21.75,22.382 C22.11,22.382 22.416,22.094 22.416,21.716 L22.416,19.754 C21.642,19.754 21.012,19.124 21.012,18.332 C20.994,17.558 21.624,16.928 22.416,16.928 Z M19.104,21.77 C18.888,21.77 18.708,21.59 18.708,21.374 C18.708,21.158 18.888,20.978 19.104,20.978 C19.32,20.978 19.5,21.158 19.5,21.374 C19.5,21.59 19.338,21.77 19.104,21.77 Z M19.104,20.762 C18.888,20.762 18.708,20.582 18.708,20.366 C18.708,20.15 18.888,19.97 19.104,19.97 C19.32,19.97 19.5,20.15 19.5,20.366 C19.5,20.582 19.338,20.762 19.104,20.762 Z M19.104,19.736 C18.888,19.736 18.708,19.556 18.708,19.34 C18.708,19.124 18.888,18.944 19.104,18.944 C19.32,18.944 19.5,19.124 19.5,19.34 C19.5,19.556 19.338,19.736 19.104,19.736 Z M19.104,18.728 C18.888,18.728 18.708,18.548 18.708,18.332 C18.708,18.116 18.888,17.936 19.104,17.936 C19.32,17.936 19.5,18.116 19.5,18.332 C19.5,18.548 19.338,18.728 19.104,18.728 Z M19.104,17.702 C18.888,17.702 18.708,17.522 18.708,17.306 C18.708,17.09 18.888,16.91 19.104,16.91 C19.32,16.91 19.5,17.09 19.5,17.306 C19.5,17.522 19.338,17.702 19.104,17.702 Z M19.104,16.694 C18.888,16.694 18.708,16.514 18.708,16.298 C18.708,16.082 18.888,15.902 19.104,15.902 C19.32,15.902 19.5,16.082 19.5,16.298 C19.518,16.514 19.338,16.694 19.104,16.694 Z M19.104,15.668 C18.888,15.668 18.708,15.488 18.708,15.272 C18.708,15.056 18.888,14.876 19.104,14.876 C19.32,14.876 19.5,15.056 19.5,15.272 C19.518,15.488 19.338,15.668 19.104,15.668 Z M23.784,14.75 L23.1,12.95 C22.362,13.22 21.552,12.842 21.282,12.122 C21.012,11.384 21.372,10.574 22.11,10.304 L21.426,8.486 C21.3,8.144 20.922,7.982 20.58,8.108 L18.474,8.9 C18.51,9.08 18.402,9.278 18.222,9.35 C18.042,9.422 17.844,9.35 17.736,9.188 L6.612,13.346 C6.27,13.472 6.108,13.85 6.234,14.192 L6.306,14.372 C6.45,14.246 6.648,14.156 6.864,14.156 L21.786,14.156 C22.254,14.156 22.614,14.534 22.614,14.984 L22.614,15.902 L23.424,15.596 C23.73,15.47 23.91,15.092 23.784,14.75 Z M18.042,10.034 C17.97,9.818 18.06,9.602 18.276,9.512 C18.492,9.44 18.708,9.53 18.798,9.746 C18.87,9.962 18.78,10.178 18.564,10.268 C18.366,10.358 18.132,10.25 18.042,10.034 Z M18.402,10.988 C18.33,10.772 18.42,10.556 18.636,10.466 C18.852,10.394 19.068,10.484 19.158,10.7 C19.23,10.916 19.14,11.132 18.924,11.222 C18.708,11.312 18.492,11.204 18.402,10.988 Z M18.762,11.942 C18.69,11.726 18.78,11.51 18.996,11.42 C19.212,11.348 19.428,11.438 19.518,11.654 C19.59,11.87 19.5,12.086 19.284,12.176 C19.068,12.266 18.834,12.158 18.762,11.942 Z M19.122,12.896 C19.05,12.68 19.14,12.464 19.356,12.374 C19.572,12.302 19.788,12.392 19.878,12.608 C19.968,12.824 19.86,13.04 19.644,13.13 C19.428,13.22 19.194,13.112 19.122,12.896 Z M20.004,14.084 C19.788,14.156 19.572,14.066 19.482,13.85 C19.41,13.634 19.5,13.418 19.716,13.328 C19.932,13.256 20.148,13.346 20.238,13.562 C20.31,13.778 20.202,14.012 20.004,14.084 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>)



export const Fab = ({ className }) => (<svg className={className} xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55">
    <defs>
        <filter id="a" width="151.1%" height="151.1%" x="-25.5%" y="-25.5%" filterUnits="objectBoundingBox">
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2" />
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0.749575408 0 0 0 0 0.122634422 0 0 0 0 0.122634422 0 0 0 0.390051355 0" />
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#a)" transform="translate(4 2)">
        <circle cx="23.5" cy="23.5" r="23.5" fill="#D0021B" />
        <g fill="#D8D8D8" transform="translate(11 20)">
            <circle cx="3" cy="3" r="3" />
            <circle cx="12" cy="3" r="3" />
            <circle cx="22" cy="3" r="3" />
        </g>
    </g>
</svg>)



export const Close = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47">
        <g fill="none" fillRule="evenodd">
            <circle cx="23.5" cy="23.5" r="23.5" fill="#4A4A4A" />
            <path d="M11 12h24v24H11z" />
            <path fill="#FFF" d="M30 18.4L28.6 17 23 22.6 17.4 17 16 18.4l5.6 5.6-5.6 5.6 1.4 1.4 5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z" />
        </g>
    </svg>)
export const ShareIcon = ({ className }) => (
    <svg className={className} width="14px" height="17px" viewBox="0 0 14 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Web-CONCEPT-DETAIL-S" transform="translate(-293.000000, -68.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="320" height="1524"></rect>
                <g id="top" transform="translate(0.000000, 56.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                    <g id="icon/share" transform="translate(294.000000, 12.000000)">
                        <g transform="translate(0.400000, 0.800000)" id="Shape">
                            <path d="M0,7.6 L0,13.68 C0,14.5194728 0.671572875,15.2 1.5,15.2 L10.5,15.2 C11.3284271,15.2 12,14.5194728 12,13.68 L12,7.6"></path>
                            <polyline points="9 3.04 6 0 3 3.04"></polyline>
                            <path d="M6,0 L6,9.88"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const PlayIconSmall = ({ className }) => (
    <svg width="37px" height="37px" viewBox="0 0 37 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1">
            <g id="video-thumbnail" transform="translate(-95.000000, -45.000000)">
                <g transform="translate(0.500000, 0.000000)" id="component/play">
                    <g transform="translate(96.000000, 46.500000)">
                        <g transform="translate(0.292308, 0.000000)">
                            <circle id="Oval" stroke="#FFFFFF" fill="#0D0D0D" opacity="0.65" cx="17" cy="17" r="17.5"></circle>
                            <path d="M23.5325734,17.5875383 L13.1687214,24.0607259 C12.9345103,24.2070125 12.626056,24.1357356 12.4797694,23.9015245 C12.4301529,23.8220863 12.4038462,23.7303093 12.4038462,23.6366492 L12.4038462,10.6902739 C12.4038462,10.4141315 12.6277038,10.1902739 12.9038462,10.1902739 C12.9975062,10.1902739 13.0892833,10.2165807 13.1687214,10.2661972 L23.5325734,16.7393848 C23.7667845,16.8856714 23.8380614,17.1941257 23.6917748,17.4283368 C23.6515009,17.492817 23.5970536,17.5472644 23.5325734,17.5875383 Z" id="Shape" fill="#FFFFFF"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const PlayIconLarge = ({ className, color, arrowColor }) => (
    <svg width="67px" height="67px" viewBox="0 0 67 67" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="library" stroke="none" strokeWidth="1">
            <g id="Icons" transform="translate(-154.000000, -1138.000000)">
                <g transform="translate(59.000000, 206.000000)">
                    <g transform="translate(1.000000, 900.000000)">
                        <g id="component/play-large" transform="translate(94.000000, 32.000000)">
                            <g transform="translate(0.907692, 0.500000)">
                                <circle id="Oval" stroke={color || "#FFFFFF"} fill={color || "#0D0D0D"} opacity="0.65" cx="32.7692308" cy="32.6923077" r="32.5"></circle>
                                <path d="M43.1716252,33.8384436 L27.5449884,43.9957576 C27.0819287,44.2967463 26.4625451,44.1653619 26.1615564,43.7023023 C26.0561197,43.540092 26,43.3507799 26,43.157314 L26,22.842686 C26,22.2904013 26.4477153,21.842686 27,21.842686 C27.1934659,21.842686 27.3827781,21.8988058 27.5449884,22.0042424 L43.1716252,32.1615564 C43.6346848,32.4625451 43.7660692,33.0819287 43.4650805,33.5449884 C43.3888594,33.6622516 43.2888884,33.7622225 43.1716252,33.8384436 Z" id="Shape" fill={arrowColor || "#ffffff"}></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const LoadingIcon = ({ className }) => (
    <svg className="loading-icon" width="51px" height="50px" viewBox="0 0 51 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="library" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="Icons" transform="translate(-611.000000, -1146.000000)" stroke="#FFFFFF" strokeWidth="2">
                <g id="🌀-UI" transform="translate(59.000000, 206.000000)">
                    <g id="📄-loading" transform="translate(452.000000, 900.000000)">
                        <g id="icon/loading-2x" transform="translate(101.600000, 41.000000)">
                            <path d="M24,0 C10.745166,0 0,10.745166 0,24 M24,48 C37.254834,48 48,37.254834 48,24"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const FullScreenIcon = ({ className }) => (
    <svg className={className} width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="Web-VIDEO-PLAYER-inline-L" transform="translate(-548.000000, -394.000000)" stroke="#FFFFFF">
                <g id="video-controls" transform="translate(38.000000, 128.000000)">
                    <g id="full-screen" transform="translate(518.084057, 274.766311) rotate(-315.000000) translate(-518.084057, -274.766311) translate(507.084057, 269.766311)">
                        <g id="&lt;" transform="translate(0.414214, 0.000000)">
                            <path d="M8.08586239,4.5 L1,4.5" id="Shape"></path>
                            <polyline id="Shape" points="4.5 9.12 0 4.56 4.5 0"></polyline>
                        </g>
                        <g id="&gt;" transform="translate(17.085786, 5.000000) scale(-1, 1) translate(-17.085786, -5.000000) translate(12.585786, -0.000000)">
                            <path d="M8.24955586,4.56 L1.24955586,4.56" id="Shape"></path>
                            <polyline id="Shape" points="4.5 9.12 9.09494702e-13 4.56 4.5 -1.41842094e-12"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const ExitFullScreenIcon = ({ className }) => (
    <svg className={className} width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g id="Web-VIDEO-PLAYER-fullscreen-L" transform="translate(-977.000000, -623.000000)" stroke="#FFFFFF">
                <g id="video-controls" transform="translate(28.000000, 120.000000)">
                    <g id="inline" transform="translate(957.084057, 511.766311) rotate(-315.000000) translate(-957.084057, -511.766311) translate(945.084057, 506.766311)">
                        <g id="&lt;-copy" transform="translate(14.142136, 0.000000)">
                            <path d="M8.08586239,4.5 L1,4.5" id="Shape"></path>
                            <polyline id="Shape" points="4.5 9.12 0 4.56 4.5 0"></polyline>
                        </g>
                        <g id="&gt;-copy" transform="translate(5.357864, 5.000000) scale(-1, 1) translate(-5.357864, -5.000000) translate(0.857864, 0.000000)">
                            <path d="M8.24955586,4.56 L1.24955586,4.56" id="Shape"></path>
                            <polyline id="Shape" points="4.5 9.12 9.09494702e-13 4.56 4.5 -1.41842094e-12"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const CheckmarkIcon = ({ className }) => (
    <svg className={className} width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Web-SetUp-Profile-M" transform="translate(-238.000000, -613.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="768" height="866"></rect>
                <g id="lightbox" transform="translate(148.000000, 83.500000)">
                    <g id="Group-2">
                        <g id="icon/check-select" transform="translate(87.000000, 526.000000)">
                            <g transform="translate(3.000000, 3.000000)">
                                <circle id="Oval" fill="#EA0000" cx="9" cy="9.5" r="9"></circle>
                                <g id="check" transform="translate(4.125000, 7.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                                    <path d="M0.408325195,2.58358046 L3.59803599,5.77329126" id="Line"></path>
                                    <path d="M3.58399687,-1.13686838e-13 L9.45428467,5.79674229" id="Line" transform="translate(6.519141, 2.898371) scale(-1, 1) translate(-6.519141, -2.898371) "></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const ClockIcon = ({ className }) => (
    <svg width="20px" height="20px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="key-screens" stroke="none" strokeWidth="1">
            <g id="Web-VIDEO-DETAIL-M" transform="translate(-109.000000, -430.000000)">
                <rect fill="#0D0D0D" x="0" y="0" width="768" height="1283"></rect>
                <g id="title" transform="translate(20.000000, 365.000000)" fill="#FFFFFF">
                    <g id="duration" transform="translate(89.000000, 65.000000)">
                        <g id="icon/clock">
                            <g id="clock">
                                <path d="M7.5,15 C11.6404358,15 15,11.6404358 15,7.5 C15,3.35956416 11.6404358,0 7.5,0 C3.35956416,0 0,3.35956416 0,7.5 C0,11.6404358 3.35956416,15 7.5,15 Z M7.5,1.05326877 C11.059322,1.05326877 13.9467312,3.94067797 13.9467312,7.5 C13.9467312,11.059322 11.059322,13.9467312 7.5,13.9467312 C3.94067797,13.9467312 1.05326877,11.059322 1.05326877,7.5 C1.05326877,3.94067797 3.94067797,1.05326877 7.5,1.05326877 Z" id="Shape" fillRule="nonzero"></path>
                                <path d="M6.77965966,8.53340793 L9.40531736,10.2117967 C9.5040263,10.2789322 9.62247702,10.3125 9.74092774,10.3125 C9.91860383,10.3125 10.0962799,10.2453645 10.1949888,10.1110934 C10.3924067,9.89290281 10.3331814,9.59079284 10.0765381,9.42295396 L7.70752366,7.91240409 L7.70752366,4.23673274 C7.70752366,3.96819054 7.45088043,3.75 7.13501183,3.75 C6.81914323,3.75 6.5625,3.96819054 6.5625,4.23673274 L6.5625,8.14737852 C6.5625,8.2984335 6.64146715,8.44948849 6.77965966,8.53340793 Z" id="Path"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const CalendarIconNEOU = ({ className }) => (
    <svg className={className} width="24px" height="25px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1">
            <g id="classRow/M" transform="translate(-707.000000, -32.000000)" stroke="#FFFFFF">
                <g id="2">
                    <g id="icon/add-to-calendar" transform="translate(707.000000, 32.000000)">
                        <g>
                            <rect id="Rectangle" x="1" y="2.5" width="17" height="17" rx="2.5"></rect>
                            <path d="M5.17142857,0.885547201 L5.17142857,4" id="Line-3" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M13.8,0.885547201 L13.8,4" id="Line-3-Copy" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path d="M1.84615385,7 L17.8461538,7" id="Line-4" strokeLinecap="square"></path>
                            <g id="Group-4" transform="translate(9.000000, 10.473517)">
                                <circle id="Oval" fill="#0D0D0D" cx="6.76257324" cy="7.23742676" r="6.76257324"></circle>
                                <path d="M6.76257324,7.23742676 L3.76257324,7.23742676 L6.76257324,7.23742676 L6.76257324,4.23742676 L6.76257324,7.23742676 Z M6.76257324,7.23742676 L9.76257324,7.23742676 L6.76257324,7.23742676 L6.76257324,10.2374268 L6.76257324,7.23742676 Z" id="Combined-Shape" strokeLinecap="round" strokeLinejoin="round"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const LeftArrow = ({ className }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" className={className} width="16" height="25" viewBox="0 0 16 25">
        <path fill="#000" fillOpacity=".729" fillRule="nonzero" d="M13.723 25a2.4 2.4 0 0 1-1.624-.607L.665 13.924c-.887-.816-.887-2.135 0-2.952L12.099.503c.907-.71 2.26-.663 3.105.11.844.774.896 2.012.12 2.843l-9.811 8.982 9.81 8.982c.657.596.857 1.496.506 2.28-.35.783-1.181 1.296-2.106 1.3z" />
    </svg>
}


export const RightArrow = ({ className }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" className={className} width="16" height="25" viewBox="0 0 16 25">
        <path fill="#000" fillOpacity=".729" fillRule="nonzero" d="M2.277 25a2.4 2.4 0 0 0 1.624-.607l11.434-10.469c.887-.816.887-2.135 0-2.952L3.901.503C2.994-.207 1.64-.16.796.613c-.844.774-.896 2.012-.12 2.843l9.811 8.982-9.81 8.982C.02 22.016-.18 22.916.17 23.7c.35.783 1.181 1.296 2.106 1.3z" />
    </svg>
}

// NEWS TEMPLATE
export const NewsFacebookSVG = ({ className }) => {
    return <svg width="43px" height="43px" viewBox="0 0 136 136" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RTA_Share-Buttons" transform="translate(-388.000000, -54.000000)" fillRule="nonzero">
                <g id="Facebook" transform="translate(388.000000, 54.000000)">
                    <rect id="Rectangle" fill="#00539C" x="0" y="0" width="136" height="136"></rect>
                    <g id="facebook-letter-logo" transform="translate(51.000000, 38.000000)" fill="#FFFFFF">
                        <path d="M6.05205209,11.6200897 C6.05205209,13.1321144 6.05205209,19.8809147 6.05205209,19.8809147 L0,19.8809147 L0,29.9822837 L6.05205209,29.9822837 L6.05205209,60 L18.4842519,60 L18.4842519,29.9831207 L26.8268351,29.9831207 C26.8268351,29.9831207 27.6081546,25.1395915 27.9868873,19.8436686 C26.9010472,19.8436686 18.5312621,19.8436686 18.5312621,19.8436686 C18.5312621,19.8436686 18.5312621,13.9670132 18.5312621,12.936956 C18.5312621,11.9046667 19.8867488,10.5160981 21.2264724,10.5160981 C22.5636851,10.5160981 25.3859766,10.5160981 28,10.5160981 C28,9.14078194 28,4.38876386 28,0 C24.5103576,0 20.5402896,0 18.790307,0 C5.74474148,-0.000697492746 6.05205209,10.1107153 6.05205209,11.6200897 Z" id="Facebook"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}

export const NewsTwitterSVG = ({ className }) => {
    return <svg width="43px" height="43px" viewBox="0 0 136 136" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RTA_Share-Buttons" transform="translate(-536.000000, -54.000000)" fillRule="nonzero">
                <g id="Twitter" transform="translate(536.000000, 54.000000)">
                    <rect id="Rectangle-Copy" fill="#00B0E2" x="0" y="0" width="136" height="136"></rect>
                    <g id="twitter" transform="translate(31.000000, 38.000000)" fill="#FFFFFF">
                        <path d="M74,7.10307692 C71.248125,8.30769231 68.315875,9.10615385 65.25875,9.49384615 C68.40375,7.62 70.804125,4.67538462 71.932625,1.12615385 C69.000375,2.87076923 65.762875,4.10307692 62.312625,4.79076923 C59.528375,1.83230769 55.560125,0 51.231125,0 C42.832125,0 36.070375,6.80307692 36.070375,15.1430769 C36.070375,16.3430769 36.172125,17.4969231 36.421875,18.5953846 C23.8095,17.9815385 12.649375,11.9492308 5.15225,2.76 C3.843375,5.02615385 3.075625,7.62 3.075625,10.4123077 C3.075625,15.6553846 5.78125,20.3030769 9.81425,22.9938462 C7.376875,22.9476923 4.98575,22.2415385 2.96,21.1292308 C2.96,21.1753846 2.96,21.2353846 2.96,21.2953846 C2.96,28.6523077 8.218625,34.7630769 15.1145,36.1707692 C13.879625,36.5076923 12.53375,36.6692308 11.137,36.6692308 C10.16575,36.6692308 9.18525,36.6138462 8.264875,36.4107692 C10.2305,42.4061538 15.80825,46.8138462 22.4405,46.9569231 C17.279,50.9861538 10.725375,53.4138462 3.630625,53.4138462 C2.3865,53.4138462 1.19325,53.3584615 0,53.2061538 C6.720125,57.5307692 14.684375,60 23.273,60 C51.1895,60 66.452,36.9230769 66.452,16.92 C66.452,16.2507692 66.428875,15.6046154 66.3965,14.9630769 C69.407375,12.8307692 71.93725,10.1676923 74,7.10307692 Z" id="Path"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}

export const NewsEmailSVG = ({ className }) => {
    return <svg width="43px" height="43px" viewBox="0 0 136 136" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RTA_Share-Buttons" transform="translate(-684.000000, -54.000000)" fillRule="nonzero">
                <g id="Email" transform="translate(684.000000, 54.000000)">
                    <rect id="Rectangle-Copy-2" fill="#B9DD00" x="0" y="0" width="136" height="136"></rect>
                    <g id="message-closed-envelope" transform="translate(29.000000, 38.000000)" fill="#FFFFFF">
                        <path d="M69.6235865,0 L9.37662025,0 C4.20639228,0 0,4.03938986 0,9.00433109 L0,50.9956689 C0,55.9606101 4.20639228,60 9.37662025,60 L69.6235865,60 C74.7938145,60 79,55.9606101 79,50.9956689 L79,9.00433109 C79,4.03938986 74.7938145,0 69.6235865,0 Z M69.6235865,52.0506362 L9.37662025,52.0506362 C8.61663313,52.0506362 7.95009382,51.5577806 7.95009382,50.9956689 L7.95009382,14.5570192 L35.1981958,37.5603924 C35.7568153,38.032161 36.4671841,38.2918199 37.1986407,38.2918199 L41.8005323,38.2920266 C42.5315754,38.2920266 43.2423577,38.032161 43.8011839,37.5603924 L71.0505264,14.5561922 L71.0505264,50.9960824 C71.0505264,51.5577806 70.3833669,52.0506362 69.6235865,52.0506362 Z M39.5001034,30.3986879 L12.99793,7.94936377 L66.0022768,7.94936377 L39.5001034,30.3986879 Z" id="Shape"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}

export const NewsGooglePlusSVG = ({ className }) => {
    return <svg width="43px" height="43px" viewBox="0 0 136 136" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RTA_Share-Buttons" transform="translate(-980.000000, -54.000000)" fillRule="nonzero">
                <g id="Google-Plus" transform="translate(980.000000, 54.000000)">
                    <rect id="Rectangle-Copy-4" fill="#F10060" x="0" y="0" width="136" height="136"></rect>
                    <g id="google-plus" transform="translate(21.000000, 38.000000)" fill="#FFFFFF">
                        <path d="M32.9064019,36.1890901 L47.5596552,36.1890901 C44.9875481,43.4597063 38.021348,48.6725314 29.8658017,48.6123693 C19.970138,48.5393152 11.7877797,40.6245138 11.4036112,30.7378673 C10.9918121,20.1401206 19.4957094,11.3871418 30.0055923,11.3871418 C34.8110751,11.3871418 39.1963673,13.21779 42.5024265,16.2175075 C43.2854997,16.9281985 44.4775067,16.9327004 45.2476857,16.2078898 L50.6297281,11.1434237 C51.4713375,10.3512887 51.4744075,9.01360174 50.6352543,8.21880654 C45.3921837,3.25256437 38.3588514,0.157078555 30.6028239,0.00565001578 C14.060043,-0.317261111 0.115976494,13.2435738 0.000746424276,29.7861185 C-0.115507003,46.4528755 13.3627271,60 30.0055923,60 C46.0107011,60 59.0855276,47.4705162 59.9613171,31.6873652 C59.9846496,31.4894849 60,24.8018686 60,24.8018686 L32.9064019,24.8018686 C31.7958542,24.8018686 30.8957088,25.7018452 30.8957088,26.8121848 L30.8957088,34.1787739 C30.8957088,35.2891134 31.7960589,36.1890901 32.9064019,36.1890901 Z" id="Path"></path>
                        <path d="M84.8777998,25.7964074 L84.8777998,18.7296668 C84.8777998,17.7743217 84.0747995,17 83.0840713,17 L76.9159287,17 C75.9252005,17 75.1222002,17.7743217 75.1222002,18.7296668 L75.1222002,25.7964074 L67.7937285,25.7964074 C66.8030003,25.7964074 66,26.5707291 66,27.5260741 L66,33.4739259 C66,34.4292709 66.8030003,35.2035926 67.7937285,35.2035926 L75.1222002,35.2035926 L75.1222002,42.2703332 C75.1222002,43.2256783 75.9252005,44 76.9159287,44 L83.0840713,44 C84.0747995,44 84.8777998,43.2256783 84.8777998,42.2703332 L84.8777998,35.2035926 L92.2062715,35.2035926 C93.1969997,35.2035926 94,34.4292709 94,33.4739259 L94,27.5260741 C94,26.5707291 93.1969997,25.7964074 92.2062715,25.7964074 L84.8777998,25.7964074 L84.8777998,25.7964074 Z" id="Path"></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
}

export const NewsArrowLeft = ({ className }) => {
    return <svg width="48px" height="140px" viewBox="0 0 48 140">
    <g id="Page-1" stroke="none" strokeWidth="1" strokeLinecap="square">
        <g id="RTA_Web_Desktop_Shows" transform="translate(-38.000000, -331.000000)" stroke="#979797" strokeWidth="5">
            <g id="Group" transform="translate(40.000000, 333.000000)">
                <path d="M1.69230769,66.3 L42.3076923,1.7" id="Line"></path>
                <path d="M1.69230769,67.7 L42.3076923,134" id="Line-Copy"></path>
            </g>
        </g>
    </g>
</svg>
}

export const NewsArrowRight = ({ className }) => {
    return <svg width="48px" height="140px" viewBox="0 0 48 140">
    <g id="Page-1" stroke="none" strokeWidth="1" strokeLinecap="square">
        <g id="RTA_Web_Desktop_Shows" transform="translate(-1282.000000, -329.000000)" stroke="#979797" strokeWidth="5">
            <g id="Group-Copy" transform="translate(1306.000000, 400.000000) rotate(-180.000000) translate(-1306.000000, -400.000000) translate(1284.000000, 333.000000)">
                <path d="M1.69230769,66.3 L42.3076923,1.7" id="Line"></path>
                <path d="M1.69230769,67.7 L42.3076923,134" id="Line-Copy"></path>
            </g>
        </g>
    </g>
</svg>
}

export const ListItemsIcon = ({ className, color }) => {
    return <svg width="80px" height="67px" viewBox="0 0 80 67" className={className}>
    <g id="Bottom-Fade-Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="List-Icon" fill={color}>
            <circle id="Oval" cx="5" cy="5" r="5"></circle>
            <circle id="Oval-Copy" cx="5" cy="33.24" r="5"></circle>
            <circle id="Oval-Copy-2" cx="5" cy="61.48" r="5"></circle>
            <rect id="Rectangle" x="20" y="-1.8189894e-12" width="60" height="10" rx="2.5"></rect>
            <rect id="Rectangle-Copy" x="20" y="28.24" width="60" height="10" rx="2.5"></rect>
            <rect id="Rectangle-Copy-2" x="20" y="56.48" width="60" height="10" rx="2.5"></rect>
        </g>
    </g>
</svg>
}

export const InfoIcon = ({ className, color }) => {
    return <svg width="80px" height="80px" viewBox="0 0 80 80" className={className}>
    <g id="Bottom-Fade-Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Info-Icon">
            <circle id="Oval" stroke={color} stroke-width="5" cx="40" cy="40" r="37.5"></circle>
            <circle id="Oval" fill={color} cx="40" cy="25" r="5"></circle>
            <rect id="Rectangle" fill={color} x="35" y="35" width="10" height="30" rx="1.5"></rect>
        </g>
    </g>
</svg>
}


export const NewsPlayIcon = ({className}) => {
    return <svg width="41px" height="41px" viewBox="0 0 41 41">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="website-show-page" transform="translate(-850.000000, -247.000000)" fill-rule="nonzero">
            <g id="Epsiode_highlight" transform="translate(765.000000, 208.000000)">
                <g id="play-2" transform="translate(85.000000, 39.000000)">
                    <circle id="Oval" fill="#42C278" cx="20.125" cy="20.585" r="19.973"></circle>
                    <polygon id="Path" fill="#282828" points="29.581 20.585 15.179 12.269 15.179 28.9"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>
}

export const CloseIconLight = ({ className, color}) => { 
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill={color}
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
      </svg>
    );
}
export const ArrowVertical = ({ className,color=""}) => { 
    return (
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.9318 7.66309C18.9318 7.43392 18.8387 7.2334 18.6525 7.06152L11.9064 0.304688C11.799 0.204427 11.6915 0.132812 11.5841 0.0898438C11.4839 0.046875 11.38 0.0253906 11.2726 0.0253906C11.0434 0.0253906 10.8501 0.100586 10.6925 0.250977C10.5421 0.394206 10.4669 0.580404 10.4669 0.80957C10.4669 0.916992 10.4848 1.02441 10.5206 1.13184C10.5636 1.2321 10.6209 1.31803 10.6925 1.38965L13.2706 4.01074L17.0734 7.50195L17.2667 7.0293L14.1085 6.85742H0.884907C0.641417 6.85742 0.444477 6.93262 0.294086 7.08301C0.143696 7.2334 0.0685005 7.42676 0.0685005 7.66309C0.0685005 7.90658 0.143696 8.10352 0.294086 8.25391C0.444477 8.4043 0.641417 8.47949 0.884907 8.47949H14.1085L17.2667 8.29688L17.0734 7.8457L13.2706 11.3262L10.6925 13.9473C10.6209 14.0189 10.5636 14.1084 10.5206 14.2158C10.4848 14.3161 10.4669 14.4199 10.4669 14.5273C10.4669 14.7565 10.5421 14.9427 10.6925 15.0859C10.8501 15.2363 11.0434 15.3115 11.2726 15.3115C11.4874 15.3115 11.6844 15.2292 11.8634 15.0645L18.6525 8.27539C18.8387 8.10352 18.9318 7.89941 18.9318 7.66309Z"
          fill={color? color:"#EDF0F2"}
        />
      </svg>
    );
}
export const ReloadIcon = ({ className}) => { 
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        x="0"
        y="0"
        version="1.1"
        width="23"
        height="19"
        viewBox="0 0 29 29"
        
      >
        <path
          fill="none"
          stroke="#000"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M20.321 21.571A10.003 10.003 0 0 1 13.25 24.5c-5.486 0-10-4.514-10-10s4.514-10 10-10 10 4.514 10 10"
        />
        <path d="M21.161 12.335h4.177a.41.41 0 0 1 .353.621l-2.089 3.509a.41.41 0 0 1-.706 0l-2.089-3.509a.412.412 0 0 1 .354-.621z" />
        <path
          fill="none"
          stroke="#000"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M20.321 21.571A10.003 10.003 0 0 1 13.25 24.5c-5.486 0-10-4.514-10-10s4.514-10 10-10 10 4.514 10 10"
        />
        <path d="M21.161 12.335h4.177a.41.41 0 0 1 .353.621l-2.089 3.509a.41.41 0 0 1-.706 0l-2.089-3.509a.412.412 0 0 1 .354-.621z" />
      </svg>
    );
}

export const StarIcon = ({ className}) => { 
    return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16"> <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.565.565 0 0 0-.163-.505L1.71 6.745l4.052-.576a.525.525 0 0 0 .393-.288L8 2.223l1.847 3.658a.525.525 0 0 0 .393.288l4.052.575-2.906 2.77a.565.565 0 0 0-.163.506l.694 3.957-3.686-1.894a.503.503 0 0 0-.461 0z"/> </svg>


    );
}
export const FilledStarIcon = ({ className}) => { 
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#BDFF69" class="bi bi-star-fill" viewBox="0 0 16 16"> <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/> </svg>

)}

export const PersonalizationSearch = ({ className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3305 7.16539C12.3305 9.99032 10.0405 12.2804 7.21556 12.2804C4.39064 12.2804 2.10059 9.99032 2.10059 7.16539C2.10059 4.34047 4.39064 2.05042 7.21556 2.05042C10.0405 2.05042 12.3305 4.34047 12.3305 7.16539ZM11.3896 12.928C10.2171 13.7787 8.77493 14.2804 7.21556 14.2804C3.28607 14.2804 0.100586 11.0949 0.100586 7.16539C0.100586 3.2359 3.28607 0.050415 7.21556 0.050415C11.1451 0.050415 14.3305 3.2359 14.3305 7.16539C14.3305 8.72467 13.8289 10.1668 12.9783 11.3392L18 16.3609L16.4112 17.9497L11.3896 12.928Z" fill="white" />
        </svg>
    )
}

export const PersonalizedCloseIcon = ({ className }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg">
        <line x1="1" y1="11"
            x2="11" y2="1"
            stroke="white"
            stroke-width="2" />
        <line x1="1" y1="1"
            x2="11" y2="11"
            stroke="white"
            stroke-width="2" />
    </svg>
    )
}
export const LeaderboardEventSliderLeft = ({ className }) => {
    return (
        <svg width="8" height="20" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 13L1 7L7 1" stroke="#8C8C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}
export const LeaderboardEventSliderRight = ({ className }) => {
    return (
        <svg width="8" height="20" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L7 7L1 1" stroke="#8C8C8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}
